import styled from 'styled-components';

export const DiaperCarouselCSS = styled.div`
  position: relative;
  border-right: 1px solid hsl(0deg 0% 0% / 10%);

  & .carousel .control-arrow,
  .carousel.carousel-slider .control-arrow {
    transition: all 0.25s ease-in;
    /* opacity: 0.4; */
    position: absolute;
    z-index: 2;
    top: 20px;
    background: none;
    border: 0;
    font-size: 32px;
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }
  & .carousel .control-arrow:hover {
    opacity: 1;
    filter: alpha(opacity=100);
  }
  & .carousel .control-arrow:before,
  & .carousel.carousel-slider .control-arrow:before {
    margin: 0 5px;
    display: inline-block;

    content: '';
  }
  & .carousel .control-disabled.control-arrow {
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: inherit;
    display: none;
  }
  & .carousel .control-prev.control-arrow {
    left: 0;
  }
  & .carousel .control-prev.control-arrow:before {
    background-image: url(https://images.myloapp.in/NestJsUploads/1668773844547-arrowforward_sWR7ZFijx.svg);
    width: 16px;
    height: 16px;
    transform: rotate(180deg);
  }
  & .carousel .control-next.control-arrow {
    right: 0;
  }
  & .carousel .control-next.control-arrow:before {
    background-image: url(https://images.myloapp.in/NestJsUploads/1668773844547-arrowforward_sWR7ZFijx.svg);
    width: 16px;
    height: 16px;
    transform: rotate(0deg);
  }
  & .carousel-root {
    outline: none;
  }
  & .carousel {
    position: relative;
    width: 100%;
  }
  & .carousel * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  & .carousel img {
    width: 100%;
    height: auto;
    display: inline-block;
    pointer-events: none;
    border-radius: 6px 0 0 6px;
    background: url(https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp);

    @media (max-width: 720px) {
      border-radius: 6px;
    }
  }
  & .carousel .carousel {
    position: relative;
  }
  & .carousel .control-arrow {
    outline: 0;
    border: 0;
    background: none;
    top: 50%;
    margin-top: -13px;
    font-size: 18px;
  }
  & .carousel .thumbs-wrapper {
    margin: 20px;
    overflow: hidden;
  }
  & .carousel .thumbs {
    transition: all 0.15s ease-in;
    transform: translate3d(0, 0, 0);
    position: relative;
    list-style: none;
    white-space: nowrap;
  }
  & .carousel .thumb {
    transition: border 0.15s ease-in;
    display: inline-block;
    margin-right: 6px;
    white-space: nowrap;
    overflow: hidden;
    border: 3px solid #fff;
    padding: 2px;
  }
  & .carousel .thumb:focus {
    border: 3px solid #ccc;
    outline: none;
  }
  & .carousel .thumb.selected,
  .carousel .thumb:hover {
    border: 3px solid #333;
  }
  & .carousel .thumb img {
    vertical-align: top;
  }
  & .carousel.carousel-slider {
    position: relative;
    margin: 0;
  }
  & .carousel.carousel-slider .control-arrow {
    top: 0;
    color: #fff;
    font-size: 26px;
    bottom: 0;
    margin-top: 0;
    padding: 5px;
  }

  & .carousel .slider-wrapper {
    overflow: hidden;
    margin: auto;
    width: 100%;

    transition: height 0.15s ease-in;
  }
  & .carousel .slider-wrapper.axis-horizontal .slider {
    -ms-box-orient: horizontal;
    display: flex;
    padding-bottom: 24px;
  }
  & .carousel .slider-wrapper.axis-horizontal .slider .slide {
    flex-direction: column;
    flex-flow: column;
  }
  & .carousel .slider-wrapper.axis-vertical {
    display: flex;
  }
  & .carousel .slider-wrapper.axis-vertical .slider {
    flex-direction: column;
  }
  & .carousel .slider {
    margin: 0;
    padding: 0;
    position: relative;
    list-style: none;
    width: 100%;
  }
  & .carousel .slider.animated {
    transition: all 0.35s ease-in-out;
  }
  & .carousel .slide {
    min-width: 100%;
    margin: 0;
    position: relative;
    text-align: center;
  }

  .carousel .slide span {
    position: unset !important;
    max-width: 60% !important;
    margin: auto !important;

    @media (max-width: 720px) {
      max-width: 80% !important;
    }
  }
  & .carousel .slide img {
    object-fit: contain;
    width: 100% !important;
    position: relative !important;
    height: unset !important;

    @media (max-width: 720px) {
      max-width: 80%;
    }
  }
  & .carousel .slide iframe {
    display: inline-block;
    width: calc(100% - 80px);
    margin: 0 40px 40px;
    border: 0;
  }
  & .carousel .slide .legend {
    position: absolute;
    bottom: 40px;
    left: 50%;
    margin-left: -45%;
    width: 90%;
    border-radius: 10px;
    background: #000;
    color: #fff;
    padding: 10px;
    font-size: 12px;
    text-align: center;
    opacity: 0.25;
    transition: opacity 0.35s ease-in-out;
  }
  & .carousel .control-dots {
    position: absolute;
    bottom: 0;
    margin: 10px 0;
    padding: 0;
    text-align: center;
    width: 100%;
    z-index: 9;

    @media (max-width: 720px) {
      margin: 4px 0;
    }
  }

  & .carousel .control-dots .dot {
    transition: all 0.25s ease-in;
    opacity: 0.4;
    filter: alpha(opacity=30);
    background: hsl(0deg, 0%, 0%, 100%);
    border-radius: 50%;
    width: clamp(6px, 1vw, 10px);
    height: clamp(6px, 1vw, 10px);
    cursor: pointer;
    display: inline-block;
    margin: 0 6px;
  }
  & .carousel .control-dots .dot.selected {
    opacity: 1;
    filter: alpha(opacity=100);
    background: #ef4e5e;
    width: clamp(16px, 3vw, 22px);
    border-radius: 10px;
  }
  & .carousel .carousel-status {
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px;
    font-size: 10px;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.9);
    color: #fff;
  }
  & .carousel:hover .slide .legend {
    opacity: 1;
  }
`;
